import React from "react";
import { Button } from "antd";
import { ModalBase } from "@aspen/ui";
import { i18nCrossUtil } from "@adgm/libs";
import { IModalConfirmProps } from "@adgm/cross-models";
import { colors } from "../../styles/common";

const crossIntl = i18nCrossUtil.t();
export const ModalConfirm: React.FC<IModalConfirmProps> = props => {
  const {
    isVisible,
    onCancelClick,
    onConfirmClick,
    children,
    title,
    confirmButtonText = crossIntl["common.confirm"],
    cancelButtonText = crossIntl["button.cancel"],
    loading,
    footer,
  } = props;

  const _renderFooter = () => {
    return [
      <Button
        key="ok"
        type="primary"
        style={{ flex: 1, backgroundColor: "#ff6500", color: colors.white, marginLeft: 0 }}
        onClick={onConfirmClick}>
        {confirmButtonText}
      </Button>,
    ];
  };

  return (
    <ModalBase
      title={title}
      open={isVisible}
      confirmLoading={loading}
      maskClosable={false}
      footer={footer || _renderFooter()}
      onOk={onConfirmClick}
      okText={confirmButtonText}
      cancelText={cancelButtonText}
      width={480}
      destroyOnClose
      onCancel={onCancelClick}>
      {children}
    </ModalBase>
  );
};
